import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Store } from '@ngrx/store';
import { AppState } from '../../../reducers';

import { EventApi } from "../../../services/webservice";
import { EventOverviewActions } from "../../../actions"

@Injectable()
export class EventListResolver implements Resolve<any> {

	constructor(
		private store: Store<AppState>,
		private eventOverviewActions: EventOverviewActions,
		private eventApi: EventApi
	) {}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		this.eventApi.overview().subscribe(eventsWithVenue => {
			this.store.dispatch(this.eventOverviewActions.eventOverviewLoaded(eventsWithVenue))
		})
	}

}



// WEBPACK FOOTER //
// ./src/app/components/event-components/event-list/event-list.resolver.ts